import _ from 'underscore';
import { UniversalJsonHelper } from '@biteinc/helpers-universal';
export function deepClone(obj) {
    const newObj = _.clone(obj);
    _.each(_.keys(newObj), (key) => {
        const value = newObj[key];
        if (_.isArray(value)) {
            newObj[key] = _.map(value, _.clone);
        }
        else if (_.isObject(value)) {
            newObj[key] = deepClone(value);
        }
    });
    return newObj;
}
export function areEqual(objects) {
    return _.all(objects, (object) => {
        return _.isEqual(object, objects[0]);
    });
}
export const replaceKeyInJSON = UniversalJsonHelper.replaceKeyInJSON;
export const replaceKeyInDict = UniversalJsonHelper.replaceKeyInDict;
export function getDifferenceBetween(a, b, excludedFields) {
    const diff = {
        a: [],
        b: [],
    };
    _.each(a, (value, key) => {
        if (_.contains(excludedFields, key.toString())) {
            return;
        }
        if (!_.has(b, key.toString())) {
            diff.a.push({ [key]: value });
            // @ts-expect-error not sure how to type this
        }
        else if (!_.isEqual(value, b[key])) {
            diff.a.push({ [key]: value });
            // @ts-expect-error not sure how to type this
            diff.b.push({ [key]: b[key] });
        }
    });
    _.each(b, (value, key) => {
        if (_.contains(excludedFields, key.toString())) {
            return;
        }
        if (!_.has(a, key.toString())) {
            diff.b.push({ [key]: value });
        }
    });
    if (diff.a.length || diff.b.length) {
        return diff;
    }
    return null;
}
export function getDifferenceBetweenWithSchema(a, b, excludedFields, schema) {
    const diff = {
        a: [],
        b: [],
    };
    _.each(a, (value, key) => {
        if (_.contains(excludedFields, key.toString())) {
            return;
        }
        const fieldSchema = schema.fields[key];
        if (!fieldSchema) {
            throw new Error(`Object A has unexpected field: ${key}`);
        }
        switch (fieldSchema.type) {
            case 'array':
                // [] vs []
                if (_.isArray(value) && _.isArray(b[key])) {
                    if (!_.isEqual(value, b[key])) {
                        diff.a.push({ [key]: value });
                        diff.b.push({ [key]: b[key] });
                    }
                    return;
                }
                // null/undefined === []
                // null/undefine vs [something]
                if (!_.isArray(value) && _.isArray(b[key]) && b[key].length > 0) {
                    diff.a.push({ [key]: value });
                    diff.b.push({ [key]: b[key] });
                    return;
                }
                // [] === null/undefined
                // [something] vs null/undefined
                if (_.isArray(value) && !_.isArray(b[key]) && value.length > 0) {
                    diff.a.push({ [key]: value });
                    diff.b.push({ [key]: b[key] });
                    return;
                }
                return;
            case 'bool': {
                // true vs false/undefined
                if (value && !b[key]) {
                    diff.a.push({ [key]: value });
                    diff.b.push({ [key]: b[key] });
                    return;
                }
                // false vs true
                if (!value && b[key]) {
                    diff.a.push({ [key]: value });
                    diff.b.push({ [key]: b[key] });
                    return;
                }
                return;
            }
            default: {
                // any vs undefined/null
                if (value && !b[key]) {
                    diff.a.push({ [key]: value });
                    diff.b.push({ [key]: b[key] });
                    return;
                }
                if (!_.isEqual(value, b[key])) {
                    diff.a.push({ [key]: value });
                    diff.b.push({ [key]: b[key] });
                }
            }
        }
    });
    _.each(b, (value, key) => {
        if (_.contains(excludedFields, key.toString())) {
            return;
        }
        const fieldSchema = schema.fields[key];
        if (!fieldSchema) {
            throw new Error(`Object B has unexpected field: ${key}`);
        }
        switch (fieldSchema.type) {
            case 'array':
                // [] vs []
                if (_.isArray(value) && _.isArray(a[key])) {
                    if (!_.isEqual(value, a[key])) {
                        diff.b.push({ [key]: value });
                    }
                    return;
                }
                // null/undefined === []
                // null/undefine vs [something]
                if (!_.isArray(value) && _.isArray(a[key]) && a[key].length > 0) {
                    diff.b.push({ [key]: value });
                    return;
                }
                // [] === null/undefined
                // [something] vs null/undefined
                if (_.isArray(value) && !_.isArray(a[key]) && value.length > 0) {
                    diff.b.push({ [key]: value });
                    return;
                }
                return;
            case 'bool': {
                // true vs false/undefined
                if (value && !a[key]) {
                    diff.b.push({ [key]: value });
                    return;
                }
                // false vs true
                if (!value && a[key]) {
                    diff.b.push({ [key]: value });
                    return;
                }
                return;
            }
            default:
                // any vs undefined/null
                if (value && !a[key]) {
                    diff.b.push({ [key]: value });
                    return;
                }
                if (!_.isEqual(value, a[key])) {
                    diff.b.push({ [key]: value });
                }
        }
    });
    if (diff.a.length || diff.b.length) {
        return diff;
    }
    return null;
}
//# sourceMappingURL=json_helper.js.map